export default __webpack_public_path__ + "static/media/unique15.bf52dbb2.PNG";